// The files a message carries, as buttons that open them (ADR-025: the send review shows the PDFs
// the customer will get — the invoice and the printed Proposal — before the click).
import {useQuery} from '@tanstack/react-query';
import {Paperclip} from 'lucide-react';
import {listDraftAttachments,openDraftAttachment} from '../lib/communication-office';
import {useT} from '../lib/i18n';
export function DraftAttachments({id}:{id:string}){
 const {t}=useT();
 const q=useQuery({queryKey:['communication',id,'attachments'],queryFn:()=>listDraftAttachments(id),staleTime:60_000});
 if(q.isPending)return <span className="text-micro text-muted-foreground">{t('attachments.loading')}</span>;
 if(q.isError||!q.data?.length)return null;
 return <div className="flex flex-wrap gap-2">{q.data.map(a=><button key={a.index} type="button" className="rounded border px-2 py-1 text-micro hover:bg-secondary" title={t('attachments.open')} onClick={()=>void openDraftAttachment(id,a.index).catch(()=>{})}><Paperclip className="mr-1 inline h-3 w-3"/>{a.name} · {a.kb} KB</button>)}</div>;
}
